const BASE_IDS = { first: "1b", second: "2b", third: "3b" };

export const FieldLines = ({ cfg }) => {
  const { base: B, mound: M, fence: F, bases } = cfg;
  const s = B / 90;
  const d = F * Math.SQRT1_2;
  const sv = ([x, y]) => [x, -y];
  const dirtR = 95 * s;
  const lineW = Math.max(1.2, F * 0.006);
  const bag = 4 * s + 2;
  const [fx, fy] = sv(bases.first);
  const [sx, sy] = sv(bases.second);
  const [tx, ty] = sv(bases.third);
  return (
    <g style={{ pointerEvents: "none" }}>
      <path d={`M0,0 L${-d},${-d} A${F},${F} 0 0 1 ${d},${-d} Z`} fill="var(--grass)" />
      <path
        d={`M${-d * 0.95},${-d * 0.95} A${F * 0.95},${F * 0.95} 0 0 1 ${d * 0.95},${-d * 0.95}`}
        fill="none" stroke="var(--track)" strokeWidth={F * 0.05} opacity="0.85"
      />
      <path d={`M${-d},${-d} A${F},${F} 0 0 1 ${d},${-d}`} fill="none" stroke="#fff" strokeWidth={lineW * 2.2} />
      <circle cx="0" cy={-M} r={dirtR} fill="var(--dirt)" />
      <path d={`M0,${-bag} L${fx - bag},${fy} L${sx},${sy + bag} L${tx + bag},${ty} Z`} fill="var(--grass)" />
      <circle cx="0" cy="0" r={13 * s + 4} fill="var(--dirt)" />
      {[bases.first, bases.second, bases.third].map((p, i) => (
        <circle key={i} cx={p[0]} cy={-p[1]} r={9 * s + 3} fill="var(--dirt)" />
      ))}
      <circle cx="0" cy={-M} r={9 * s + 2} fill="var(--mound)" />
      <rect x={-2.5 * s - 1} y={-M - 0.6} width={5 * s + 2} height={1.4} fill="#fff" />
      <line x1="0" y1="0" x2={-d} y2={-d} stroke="#fff" strokeWidth={lineW} />
      <line x1="0" y1="0" x2={d} y2={-d} stroke="#fff" strokeWidth={lineW} />
      <path d={`M${fx},${fy} L${sx},${sy} L${tx},${ty}`} fill="none" stroke="#fff" strokeWidth={lineW * 0.6} opacity="0.55" />
      {Object.entries(BASE_IDS).map(([k, id]) => {
        const [x, y] = sv(bases[k]);
        return (
          <rect key={k} data-testid={`base-${id}`} x={x - bag / 2} y={y - bag / 2} width={bag} height={bag} fill="#fff" transform={`rotate(45 ${x} ${y})`} />
        );
      })}
      <path d={`M0,${bag * 0.2} L${bag / 2},${-bag * 0.3} L${bag / 2},${-bag * 0.8} L${-bag / 2},${-bag * 0.8} L${-bag / 2},${-bag * 0.3} Z`} fill="#fff" />
    </g>
  );
};
